import React from 'react';
import { func, node, number, oneOfType, string } from 'prop-types';
import { OverlayTrigger } from 'react-bootstrap';
import { Typography } from '@ajaibid/components';
import { noop } from '@ajaibid/utils';
import { styBtnTooltip } from './style';

const ButtonTooltip = (props) => {
  const { className, description, onClick, position, size, src, title } = props;

  return (
    <OverlayTrigger
      placement={position}
      overlay={(
        <div className={styBtnTooltip}>
          {title && (
            <Typography type="body" bold style={{ marginTop: 0 }}>
              {title}
            </Typography>
          )}
          {typeof description === 'string' ? (
            <Typography type="label">{description}</Typography>
          ) : (
            description
          )}
        </div>
      )}
    >
      <div role="button" onClick={onClick} className={className} style={{ cursor: 'pointer' }}>
        <img src={src} width={size} height={size} alt="icon" />
      </div>
    </OverlayTrigger>
  );
};

ButtonTooltip.propTypes = {
  className: string,
  description: oneOfType([string, node]),
  onClick: func,
  position: string,
  size: number,
  src: string,
  title: string,
};

ButtonTooltip.defaultProps = {
  className: '',
  description: '',
  onClick: noop,
  position: 'top',
  size: 16,
  src: '',
  title: '',
};

export default ButtonTooltip;
